var map = {
	"./icon-addCus.svg": 35627,
	"./icon-admin.svg": 69692,
	"./icon-bianji.svg": 23850,
	"./icon-caiwu.svg": 83752,
	"./icon-config.svg": 50189,
	"./icon-dangdifill.svg": 59697,
	"./icon-daohang.svg": 85941,
	"./icon-data.svg": 8935,
	"./icon-duanxin.svg": 25188,
	"./icon-editor.svg": 26432,
	"./icon-file.svg": 18057,
	"./icon-geren.svg": 21786,
	"./icon-jiesuo.svg": 95776,
	"./icon-jixiao.svg": 29237,
	"./icon-job.svg": 79924,
	"./icon-kucun.svg": 42987,
	"./icon-log.svg": 63395,
	"./icon-menu.svg": 86590,
	"./icon-mudedi.svg": 46353,
	"./icon-oss.svg": 2132,
	"./icon-paiqi.svg": 47993,
	"./icon-pdf.svg": 77671,
	"./icon-phone.svg": 66117,
	"./icon-pinglun.svg": 32040,
	"./icon-role.svg": 20635,
	"./icon-shanchu.svg": 1959,
	"./icon-shebei.svg": 10813,
	"./icon-shezhi.svg": 65770,
	"./icon-shoucang.svg": 45743,
	"./icon-shoucangfill.svg": 32120,
	"./icon-shouye.svg": 98948,
	"./icon-sousuo.svg": 81190,
	"./icon-sql.svg": 12949,
	"./icon-suoding.svg": 88022,
	"./icon-system.svg": 18564,
	"./icon-time.svg": 23308,
	"./icon-tixing.svg": 85330,
	"./icon-todayWork.svg": 61497,
	"./icon-tubiao.svg": 62537,
	"./icon-vip.svg": 25016,
	"./icon-xiangmu.svg": 90700,
	"./icon-xiangqu.svg": 82816,
	"./icon-xiangqufill.svg": 43259,
	"./icon-yanzhi.svg": 28744,
	"./icon-yiliao.svg": 82340,
	"./icon-yingxiao.svg": 81149,
	"./icon-zhedie.svg": 85192,
	"./icon-zonghe.svg": 82162,
	"./icon-zonglan.svg": 27280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;